let editor = null;
let editorReady = false;

document.addEventListener("click", function(e) {
    const btn = e.target.closest(".add-to-cart-button");
    if (!btn) return;

    let settings, editorConfig;
    try {
        settings = JSON.parse(btn.dataset.product);
        
        let templateName = settings.templateName;
        const product = settings?.product;      
        const variantMetaData = {};
        
        product.optionDetails = settings.optionDetails;
        if(product && product.variants) {
            product.variants = product.variants.filter((x) => {
            if(variantMetaData[x.id]) {
                if(variantMetaData[x.id].hideFromEditor === true) {
                return false;
                }
                if(variantMetaData[x.id].templateName) {
                x.templateName = variantMetaData[x.id].templateName;
                } else {
                x.templateName = templateName || null;
                }
                if(variantMetaData[x.id].productDefinitionId) {
                x.productDefinitionId = variantMetaData[x.id].productDefinitionId;
                }
            }
            return true;
            });
        }
        if (!editor) {
            if (!settings?.shopToken) {
            console.error("No shop token provided", editorConfig);
            return;
            }

            editor = initPrintessShopifyEditor(settings);
            editorReady = true;
        }

        if (!editorReady || !editor?.initProductPage) {
            console.error("Printess editor not ready");
            return;
        }
        
        editor.show(settings);

    } catch (err) {
        return console.error("Invalid JSON in button data attributes", err);
    }
});